var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Tabs as MUITabs, Tab as MUITab } from "@mui/material";
import { styled } from "@mui/material/styles";
export function TabPanel(props) {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return (_jsx("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `tabpanel-${index}`, "aria-labelledby": `tab-${index}` }, other, { children: value === index && _jsx(_Fragment, { children: children }) })));
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
export const Tabs = styled((props) => (_jsx(MUITabs, Object.assign({}, props, { TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }) } }))))({
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
    },
    "& .MuiTabs-indicatorSpan": {
        width: "100%",
        backgroundColor: "#4E3BC9",
        borderRadius: "4px 4px 0px 0px",
        margin: "-2px",
    },
});
export const Tab = styled((props) => _jsx(MUITab, Object.assign({ disableRipple: true }, props)))(({ theme }) => ({
    textTransform: "capitalize",
    fontWeight: 400,
    fontSize: "14px",
    marginRight: theme.spacing(1),
    paddingBottom: "0px",
    paddingTop: "0px",
    minHeight: "50px",
    color: theme.palette.text.mid,
    "&.Mui-selected": {
        color: theme.palette.text.dark,
        fontWeight: 600,
    },
}));
